import { Grid } from '@mui/material';
import { set } from 'lodash';
import { forwardRef } from 'react';
import {
  ColorPickerWidget,
  NumberInputWidget,
  SelectDropdownWidget,
} from 'src/components/widget';
import { FONT_FAMILY_OPTIONS } from 'src/constants';
import { useGetProjectConfig } from 'src/hooks';
import type { IThemeRes } from 'src/interfaces';
import { lang } from 'src/utils';

import { badgeTypeOptions, generateBadgeSizeOption } from '../helper';

export interface ComboProductBadgeConfig {
  value: any;
  currentTheme?: IThemeRes;
  onChange: (value: ComboProductBadgeConfig) => void;
}

export const ComboStyleProductBadge = forwardRef<
  HTMLDivElement,
  ComboProductBadgeConfig
>((props, ref) => {
  const { data: projectConfig } = useGetProjectConfig();

  const projectFonts =
    projectConfig?.fonts?.map((item) => ({
      label: item.name,
      value: item.name,
    })) ?? [];
  const mappedFonts =
    projectFonts.length > 0 ? projectFonts : FONT_FAMILY_OPTIONS;

  const onFieldChange = (field: string) => (value: unknown) => {
    const newValue = set({ ...props.value }, field, value);

    props.onChange(newValue);
  };

  return (
    <Grid container spacing={2} ref={ref}>
      <Grid item xs={6}>
        <SelectDropdownWidget
          label={lang.type}
          value={props.value?.type}
          onChange={onFieldChange('type')}
          selectOptions={badgeTypeOptions}
        />
      </Grid>

      <Grid item xs={6}>
        <SelectDropdownWidget
          label={lang.fontFamily}
          value={
            props.value?.style?.font ??
            props.currentTheme?.config.badges?.itemBadge?.font
          }
          selectOptions={mappedFonts}
          onChange={onFieldChange('style.font')}
        />
      </Grid>

      <Grid item xs={6}>
        <NumberInputWidget
          label={lang.fontSize}
          value={
            props.value?.style?.fontSize ??
            props.currentTheme?.config.badges?.itemBadge?.fontSize
          }
          onChange={onFieldChange('style.fontSize')}
          options={{ suffix: 'px' }}
        />
      </Grid>

      <Grid item xs={6}>
        <ColorPickerWidget
          label={lang.fontColor}
          value={
            props.value?.style?.color ??
            props.currentTheme?.config.badges?.itemBadge?.color
          }
          onChange={onFieldChange('style.color')}
          pickerWrapperStyle={{ left: '-50px' }}
        />
      </Grid>

      <Grid item xs={6}>
        <NumberInputWidget
          label={lang.lineHeight}
          value={
            props.value?.style?.lineHeight ??
            props.currentTheme?.config.badges?.itemBadge?.lineHeight
          }
          onChange={onFieldChange('style.lineHeight')}
          options={{ suffix: 'px' }}
        />
      </Grid>
      <Grid item xs={6} />

      <Grid item xs={6}>
        <SelectDropdownWidget
          label={lang.badgeSize}
          value={
            props.value?.style?.size ??
            props.currentTheme?.config.badges?.itemBadge?.size
          }
          selectOptions={generateBadgeSizeOption(150)}
          onChange={onFieldChange('style.size')}
          options={{ suffix: 'px' }}
        />
      </Grid>
      <Grid item xs={6}>
        <ColorPickerWidget
          label={lang.badgeBackground}
          value={
            props.value?.style?.background ??
            props.currentTheme?.config.badges?.itemBadge?.backgroundColor
          }
          onChange={onFieldChange('style.background')}
          options={{
            backgroundColor: true,
          }}
          pickerWrapperStyle={{ left: '-50px' }}
        />
      </Grid>

      <Grid item xs={6}>
        <SelectDropdownWidget
          label={lang.barWidth}
          value={
            props.value?.style?.barWidth ??
            props.currentTheme?.config.badges?.itemBadge?.barWidth
          }
          selectOptions={generateBadgeSizeOption(150)}
          onChange={onFieldChange('style.barWidth')}
          options={{ suffix: 'px' }}
        />
      </Grid>
    </Grid>
  );
});
